import React from 'react'
import { Button, Row, Col, Badge } from 'reactstrap'

interface ContractLineHeaderProps {
  contractLineId: number | undefined
  onBackToSearch: () => void
}

const ContractLineHeader: React.FC<ContractLineHeaderProps> = ({
  contractLineId,
  onBackToSearch,
}) => {
  return (
    <>
      <p>
        <Button color="primary" onClick={onBackToSearch} outline>
          <i className="fas fa-chevron-left" />
          &nbsp; Back to Search
        </Button>
      </p>
      <Row style={{ backgroundColor: '#002855' }}>
        <Col>
          <h2 className="mt-2 text-light">
            Contract Line&nbsp;
            <Badge color="light">NS ID: {contractLineId}</Badge>
            &nbsp;
          </h2>
        </Col>
      </Row>
    </>
  )
}

export default ContractLineHeader
